/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IAPYESORNO } from './IAPYESORNO';
import {
    IAPYESORNOFromJSON,
    IAPYESORNOFromJSONTyped,
    IAPYESORNOToJSON,
} from './IAPYESORNO';

/**
 * 
 * @export
 * @interface ProposalSummaryOrganisationDetails
 */
export interface ProposalSummaryOrganisationDetails {
    /**
     * 
     * @type {string}
     * @memberof ProposalSummaryOrganisationDetails
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof ProposalSummaryOrganisationDetails
     */
    registrationNumber?: string;
    /**
     * 
     * @type {IAPYESORNO}
     * @memberof ProposalSummaryOrganisationDetails
     */
    areAllBeneficiariesIndividuals?: IAPYESORNO;
}

/**
 * Check if a given object implements the ProposalSummaryOrganisationDetails interface.
 */
export function instanceOfProposalSummaryOrganisationDetails(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ProposalSummaryOrganisationDetailsFromJSON(json: any): ProposalSummaryOrganisationDetails {
    return ProposalSummaryOrganisationDetailsFromJSONTyped(json, false);
}

export function ProposalSummaryOrganisationDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProposalSummaryOrganisationDetails {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'Name') ? undefined : json['Name'],
        'registrationNumber': !exists(json, 'RegistrationNumber') ? undefined : json['RegistrationNumber'],
        'areAllBeneficiariesIndividuals': !exists(json, 'AreAllBeneficiariesIndividuals') ? undefined : IAPYESORNOFromJSON(json['AreAllBeneficiariesIndividuals']),
    };
}

export function ProposalSummaryOrganisationDetailsToJSON(value?: ProposalSummaryOrganisationDetails | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'Name': value.name,
        'RegistrationNumber': value.registrationNumber,
        'AreAllBeneficiariesIndividuals': IAPYESORNOToJSON(value.areAllBeneficiariesIndividuals),
    };
}

